"use strict";

exports.__esModule = true;
exports.observePageVisibility = observePageVisibility;

var _constants = require("../constants");

var _state = require("../../state");

var _utils = require("../utils");

function observePageVisibility(configService, transactionService) {
  if (document.visibilityState === 'hidden') {
    _state.state.lastHiddenStart = 0;
  }

  var visibilityChangeHandler = function visibilityChangeHandler() {
    if (document.visibilityState === 'hidden') {
      onPageHidden(configService, transactionService);
    }
  };

  var pageHideHandler = function pageHideHandler() {
    return onPageHidden(configService, transactionService);
  };

  var useCapture = true;
  window.addEventListener('visibilitychange', visibilityChangeHandler, useCapture);
  window.addEventListener('pagehide', pageHideHandler, useCapture);
  return function () {
    window.removeEventListener('visibilitychange', visibilityChangeHandler, useCapture);
    window.removeEventListener('pagehide', pageHideHandler, useCapture);
  };
}

function onPageHidden(configService, transactionService) {
  var tr = transactionService.getCurrentTransaction();

  if (tr) {
    var unobserve = configService.observeEvent(_constants.QUEUE_ADD_TRANSACTION, function () {
      configService.dispatchEvent(_constants.QUEUE_FLUSH);
      _state.state.lastHiddenStart = (0, _utils.now)();
      unobserve();
    });
    tr.end();
  } else {
    configService.dispatchEvent(_constants.QUEUE_FLUSH);
    _state.state.lastHiddenStart = (0, _utils.now)();
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@elastic/apm-rum-core/dist/lib/common/observers/page-visibility.js
// module id = 434
// module chunks = 0